export const EXPLICIT_LOGOUT_KEY = "railaxis_explicit_logout";
export const LOGIN_REDIRECT_KEY = "railaxis_login_redirect";

export function getSafeRedirectPath(path) {
  const value = String(path || "").trim();
  if (!value || value === "/" || !value.startsWith("/") || value.startsWith("//") || value.startsWith("/login")) {
    return "/";
  }
  return value;
}

export function clearLoginRedirect() {
  sessionStorage.removeItem(LOGIN_REDIRECT_KEY);
}

export function consumeExplicitLogout() {
  if (sessionStorage.getItem(EXPLICIT_LOGOUT_KEY) !== "1") return false;
  sessionStorage.removeItem(EXPLICIT_LOGOUT_KEY);
  clearLoginRedirect();
  return true;
}

export function buildLoginPath(redirectPath = "/") {
  const safeRedirect = getSafeRedirectPath(redirectPath);
  if (safeRedirect === "/") {
    clearLoginRedirect();
    return "/login";
  }

  sessionStorage.setItem(LOGIN_REDIRECT_KEY, safeRedirect);
  return `/login?redirect=${encodeURIComponent(safeRedirect)}`;
}

export function getLoginRedirect(params) {
  if (consumeExplicitLogout()) {
    if (typeof window !== "undefined") {
      window.history.replaceState(null, "", "/login");
    }
    return "/";
  }

  const storedRedirect = getSafeRedirectPath(sessionStorage.getItem(LOGIN_REDIRECT_KEY));
  const requestedRedirect = getSafeRedirectPath(params.get("redirect"));
  if (storedRedirect !== "/" && storedRedirect === requestedRedirect) return storedRedirect;
  if (storedRedirect !== "/" && requestedRedirect === "/") return storedRedirect;
  return "/";
}
